<template>
  <section
    class="component-a0c1dfbe"
    resmed-component-name="info_25/75_icon-line_text_list_text_image"
    v-bind:style="{
      'background-color': acf.layout['background-color'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row">
          <div
            class="
              col-md-5 col-lg-5 col-xl-5
              order-md-1 order-lg-2
              mb-5 mb-md-0
            "
          >
            <div
              v-if="acf.animation"
              class="animation"
              v-bind:style="transform"
            >
              <animation
                v-bind:animation="JSON.parse(acf.animation)"
              ></animation>
            </div>
            <div v-if="acf.image" v-bind:style="transform">
              <figure>
                <img class="img-fluid" v-bind:src="acf.image" alt="" />
              </figure>
            </div>
          </div>

          <div class="col-md-7 col-lg-7 col-xl-7 order-md-2 order-lg-1">
            <div>
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
              ></eyebrow-icon>
              <div v-if="acf.name" class="title">
                <h5>{{ acf.name }}</h5>
              </div>

              <h2 v-html="acf.headline"></h2>
              <div v-if="acf.content" v-html="acf.content"></div>

              <ul v-if="acf['list-items']" class="mt-4">
                <li
                  v-for="(content, index) in acf['list-items']"
                  v-html="content.item"
                ></li>
              </ul>

              <div
                v-if="acf['additional-content']"
                v-html="acf['additional-content']"
              ></div>

              <a
                v-if="acf.cta.text"
                v-bind:href="acf.cta.href"
                class="btn mt-4"
                v-bind:target="acf.cta.target"
                v-bind:class="{
                  'cta-plain text-red icon right-arrow':
                    acf.cta.style === 'text',
                  'cta-pill filled-red icon right-arrow':
                    acf.cta.style === 'pill',
                }"
                >{{ acf.cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-a0c1dfbe", // info_25/75_icon-line_text_list_text_image
  props: ["acf"],
  data() {
    return {
      transform: {
        transform: this.acf.layout["animation-transform"],
      },
    };
  },
  watch: {
    "$root.mode": {
      handler(val) {
        if (val === "xs" || val === "sm") {
          this.transform["transform"] = this.acf.layout[
            "animation-transform-xs"
          ]
            ? this.acf.layout["animation-transform-xs"]
            : this.acf.layout["transform"];
        } else {
          this.transform["transform"] = this.acf.layout["animation-transform"];
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-a0c1dfbe {
  padding: 3rem 0;

  @media (min-width: 768px) {
    padding: 6rem 0 5rem 0;
  }
}

.component {
  .animation {
    @media (min-width: 1200px) {
      transform: translateX(2rem) scale(1.125);
    }
  }

  .title {
    h5 {
      position: relative;
      @extend %body-normal-bold;
      @extend %eyebrow-left;
    }

    + h2 {
      &:before {
        display: none;
      }
    }
  }

  h2 {
    margin-bottom: 1.25rem;
    position: relative;

    @extend %eyebrow-left;
  }

  figure {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ul {
    padding-left: 1.125rem;

    li {
      margin-bottom: 1.25rem;
      padding-bottom: 1.25rem;
      border-bottom: 1px solid rgba($cc-resmed-grey-50, 0.25);
    }
  }
}
</style>